import React from 'react';

import { getAppConfig } from '@config/get-app-config';
import { initializeSentry } from '@services/sentry-service';
import { setDocumentLang } from '@utilities/utilities';

import App from './app';

// A div with this id must be available within the parent page
const container = document.getElementById('checkout-frontend') as HTMLElement;
const appConfig = getAppConfig();

if (appConfig) {
  initializeSentry(appConfig);
  setDocumentLang(appConfig.site.language);
}

import('react-dom').then((ReactDOM) => {
  ReactDOM.render(
    <React.StrictMode>
      <App {...appConfig} />
    </React.StrictMode>,
    container,
  );
});
